module.exports = __webpack_public_path__ + "static/media/reactstrap.42ac80a3.png";